<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 24 27.367">
        <g id="Group_2731" data-name="Group 2731" transform="translate(-20 -307)">
            <g id="Group_2730" data-name="Group 2730" transform="translate(0 108)">
                <g id="Group_2727" data-name="Group 2727" transform="translate(-2.485 -2.28)">
                    <circle id="Ellipse_197" data-name="Ellipse 197" cx="12" cy="12" r="12"
                            transform="translate(22.485 201.28)" fill="#c0d0fc"/>
                </g>
            </g>
            <g id="location_2_" data-name="location (2)" transform="translate(-63.951 312.133)">
                <path id="Path_70084" data-name="Path 70084"
                      d="M159.627,92.729l-3.82-2.618a.622.622,0,0,0-.706,0l-3.82,2.618a.666.666,0,0,0-.177.908.626.626,0,0,0,.883.182l.284-.194v3.621a.646.646,0,0,0,.637.655H158a.646.646,0,0,0,.637-.655V93.624l.284.194a.626.626,0,0,0,.883-.182A.666.666,0,0,0,159.627,92.729Zm-2.263,3.861h-3.82V92.751l1.91-1.309,1.91,1.309Z"
                      transform="translate(-57.379 -86.103)" fill="#799cfb"/>
                <path id="Path_70085" data-name="Path 70085"
                      d="M98.075,0A7.126,7.126,0,0,0,91,7.16c0,4.137,3.913,9.487,6.617,12.261a.638.638,0,0,0,.916,0c2.743-2.814,6.617-8.145,6.617-12.261A7.126,7.126,0,0,0,98.075,0Zm0,18.013c-1.442-1.6-5.788-6.758-5.788-10.852a5.789,5.789,0,1,1,11.577,0C103.863,11.25,99.516,16.414,98.075,18.013Z"
                      fill="#799cfb"/>
                <path id="Path_70086" data-name="Path 70086"
                      d="M151.637,482a.655.655,0,0,0,0,1.309h7.64a.655.655,0,0,0,0-1.309Z"
                      transform="translate(-57.382 -461.076)" fill="#799cfb"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "IHome",
        props: {
            width: {
                type: String,
                default: '1.5em'
            },
            height: {
                type: String,
                default: '1.5em'
            }
        }
    }
</script>

<style scoped>

</style>
